export default {
  name: 'bridge-authorization',
  cdn: {
    edge: 'https://d1h1778jwn2brc.cloudfront.net',
    staging: 'https://d2wzd4gs88w14e.cloudfront.net',
    production: 'https://d3fuoknb3jgind.cloudfront.net',
  },
  manifest: '/authorization/assets/manifests/manifest.json',
  pathPatterns: [
    /^\/terms/,
    /^\/privacy_policy/,
    /^\/auth\//,
    /^\/error$/,
    /^\/forgot-password/,
    /^\/login/,
    /^\/logout/,
    /^\/no_user/,
    /^\/user-setup/,
    /^\/reset-password/,
    /^\/signed-out/,
  ],
  disabledNavPaths: [
    /^\/terms/,
    /^\/privacy_policy/,
    /^\/auth\//,
    /^\/forgot-password/,
    /^\/login/,
    /^\/logout/,
    /^\/no_user/,
    /^\/user-setup/,
    /^\/reset-password/,
    /^\/signed-out/,
  ],
  stylesheets: ['stylesheets_authorization_css', 'stylesheets_external_css'],
  scripts: ['javascripts_authorization_js'],
};



// WEBPACK FOOTER //
// ./jsapp/authorization/learn-runtime.js